module.exports = __webpack_public_path__ + "static/media/Portrait-10217.22d831af.jpg";